// Boot-time content registration (Fase 3).

import { loadContentPack } from '../data/loader';
import { setContentSpawnEnabled } from '../core/spawn';
import { loadAtlasManifest } from '../render/atlas';

// Side-effect: register legacy + new behaviors.
import '../core/behaviors/legacy-demon';
import '../core/behaviors/legacy-boss';
import '../core/behaviors/wander-shoot';
import '../core/behaviors/dash-blink';

// Side-effect: register abilities.
import '../core/abilities/psi-circuit';
import '../core/abilities/reflect-shield';
import '../core/abilities/dash-blink';

import { listBehaviors } from '../core/behaviors/registry';
import { listAbilities } from '../core/abilities';

export async function initContent(): Promise<void> {
  const pack = loadContentPack();
  setContentSpawnEnabled(true);
  await loadAtlasManifest('./assets/atlas.json');
  console.info(
    `[content] loaded ${pack.enemies.length} enemies, ${pack.bosses.length} bosses, ${pack.abilities.length} abilities`
  );
  console.info(`[content] behaviors: ${listBehaviors().join(', ')}`);
  console.info(`[content] abilities: ${listAbilities().map((a) => a.id).join(', ')}`);
}
